import React   from 'react';
import Spinner from './spinner';

export default () => {
  return (
    <div className="loading-spinner">
      <Spinner />
    </div>
  );
}
